import { atom } from 'recoil'

export type Loader = boolean

export const loaderState = atom<Loader>({
  key: 'loader',
  default: false,
})
